export default "__VITE_ASSET__BFgaZbxX__";